                                                              import React, {useState} from "react";
import {Box, CircularProgress, Container, List, ListItem, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import axios from "axios";
                                                              import {API_BASE_URL} from "./SignUp";

const FindPassword: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const [accountId, setAccountId] = useState('');
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleFindPassword = async () => {
        setIsLoading(true); // 로딩 시작

        try {
            await axios.post(`${API_BASE_URL}/find-password`, {
                accountId,
                email
            });

            window.alert("이메일로 비밀번호가 발송되었습니다.")
        } catch (error) {
            window.alert("아이디 및 이메일이 맞는지 다시 한 번 확인해주세요.")
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Container maxWidth="xs" style={{ marginTop: '50px' }}>
                <Typography variant="h5" align="center" gutterBottom>
                    비밀번호 찾기
                </Typography>
                <TextField
                    label="아이디"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={accountId}
                    onChange={(e) => setAccountId(e.target.value)}
                    disabled={isLoading} // 로딩 중일 때 비활성화
                />
                <TextField
                    label="이메일"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading} // 로딩 중일 때 비활성화
                />
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleFindPassword}
                    sx={{ mt: 2 }}
                    disabled={isLoading} // 로딩 중일 때 비활성화
                    style={{
                        marginBottom: '10px'
                    }}
                >
                    비밀번호 찾기
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={onClose}
                    style={{
                        marginBottom: '2rem'
                    }}
                >
                    닫기
                </Button>

                {/* 로딩 오버레이 */}
                {isLoading && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            bgcolor: 'rgba(255, 255, 255, 0.8)', // 반투명 배경
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                )}
            </Container>
        </>
    );
}

export default FindPassword